import React, { Component } from 'react'
import { message, Button, Modal, Spin, Tree, Icon, Select }   from 'antd'

import SyntaxHighlighter, { registerLanguage } from "react-syntax-highlighter/light"
import {xml, json}                             from 'react-syntax-highlighter/languages/hljs'
import { docco }                               from 'react-syntax-highlighter/styles/hljs'

import CloudFlyerAPI         from '../../api/CloudFlyerAPI'

import './styles.scss'

export default class MediaInfo extends Component {

    constructor (props) {
        super(props)
        this.state = {
            metadata:'',
            file:{},
            new_metadata:[],
            new_metadata_key:'',
            new_metadata_value:'',
            download_links:[],
            format:'',
            formats : [
                {
                    name :'',
                    mime:'',
                    description :'Default'
                },
                {
                    name :'Text',
                    mime:'text/plain',
                    description :'Text'
                },
                {
                    name :'HTML',
                    mime:'text/html',
                    description :'HTML'
                },
                {
                    name :'XML',
                    mime:'text/xml',
                    description :'MediaInfo XML'
                },
                {
                    name :'JSON',
                    mime:'text/json',
                    description :'MediaInfo JSON'
                },
                {
                    name :'EBUCore_1.8_ps',
                    mime:'text/xml',
                    description :'EBUCore 1.8 (XML; acq. metadata: parameter then segment)'
                },
                {
                    name :'EBUCore_1.8_sp',
                    mime:'text/xml',
                    description :'EBUCore 1.8 (XML; acq. metadata: segment then parameter)'
                },
                {
                    name :'EBUCore_1.8_ps_JSON',
                    mime:'text/json',
                    description :'EBUCore 1.8 (JSON; acq. metadata: parameter then segment)'
                },
                {
                    name :'EBUCore_1.8_sp_JSON',
                    mime:'text/json',
                    description :'EBUCore 1.8 (JSON; acq. metadata: segment then parameter)'
                },
                {
                    name :'EBUCore_1.6',
                    mime:'text/xml',
                    description :'EBUCore 1.6'
                },
                {
                    name :'FIMS_1.3',
                    mime:'text/xml',
                    description :'FIMS 1.3'
                },
                {
                    name :'MPEG-7',
                    mime:'text/xml',
                    description :'MPEG-7'
                },
                {
                    name :'PBCore_2.1',
                    mime:'text/xml',
                    description :'PBCore 2.1'
                },
                {
                    name :'PBCore_2.0',
                    mime:'text/xml',
                    description :'PBCore 2.0'
                },
                {
                    name :'PBCore_1.2',
                    mime:'text/xml',
                    description :'PBCore 1.2'
                }
            ]
        }

        registerLanguage('xml', xml)
        registerLanguage('json', json)
    }

    open = file => this.setState({visible:true, loading:true, file}, ()=> this.refresh(this.state.format))

    close = () => this.setState({ visible:false }, this.state.on_close)

    refresh = (format, update) =>{
        let $this = this
        $this.setState({loading: !update})

        CloudFlyerAPI
            .metadata
            .all(this.state.file.cloud_account_id, this.state.file.bucket_name, this.state.file.path, format ? format : '', this.state.file.file_id)
            .then(({data:metadata})=> $this.setState({format: format}, () => $this.setState({metadata, loading: false, new_metadata: []})))
            .catch(err=>{
                message.error(err.message)
                $this.setState({loading:false})
            })
    }

    on_new_metadata_input = (index, key, value)=>{
        let new_metadata                    = this.state.new_metadata
        //this.state.new_metadata[index][key] = value
        new_metadata[index][key] = value
        this.setState({new_metadata})
    }

    on_add_new_metadata = () =>{
        let new_metadata = this.state.new_metadata
        new_metadata.push({
            key:'',
            value:''
        })
        this.setState({new_metadata})
    }

    on_remove_new_metadata = (index, key) =>{
        let new_metadata      = this.state.new_metadata
        new_metadata.splice(index, 1)
        this.setState({new_metadata})
    }

    on_delete_metadata = (index, key) =>{
        let $this = this
        this.setState({loading:true})
        const {cloud_account_id, bucket_name, path} = this.state.file
        let metadata = this.state.metadata.metadata[index]

        CloudFlyerAPI
            .metadata
            .delete(cloud_account_id, bucket_name, path, metadata.name)
            .then(()=> $this.refresh(this.state.format))
            .catch(err=> {
                $this.setState({loading:false})
                message.error(err.message)
            })
    }

    on_save = ()=>{
        if(!this.state.new_metadata.length){
            this.close()
        }

        const {cloud_account_id, bucket_name, path} = this.state.file
        let metadata = this.state
            .new_metadata
            .map(m=>({
                cloud    : cloud_account_id,
                storage  : bucket_name,
                path     : path,
                category : "Custom",
                name     : m.key,
                value    : m.value
            }))

        let $this = this
        this.setState({loading:true})
        CloudFlyerAPI
            .metadata
            .save(metadata)
            .then(()=> $this.refresh(this.state.format, true))
            .catch(err=> {
                this.setState({loading:false})
                message.error(err.message)
            })
    }

    on_format_change = format => this.refresh(format)

    on_download = () =>{
        try {
            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(this.state.metadata)))
            element.setAttribute('download', 'mediaInfo' + (this.state.format.includes('JSON')?'.json':'.xml'))
            element.style.display = 'none';
            document.body.appendChild(element)
            element.click()
            document.body.removeChild(element)
        } catch (e){}
    }

    on_copy= () =>{
        try {
            let textArea              = document.createElement("textarea");
            textArea.style.position   = 'fixed'
            textArea.style.top        = 0
            textArea.style.left       = 0
            textArea.style.width      = '2em'
            textArea.style.height     = '2em'
            textArea.style.padding    = 0
            textArea.style.border     = 'none'
            textArea.style.outline    = 'none'
            textArea.style.boxShadow  = 'none'
            textArea.style.background = 'transparent'
            textArea.value            = JSON.stringify(this.state.metadata)
            document.body.appendChild(textArea);
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
        } catch (e) {}

        message.success('Metadata copied!')
    }

    render() {
        const {loading, visible, metadata, file:{path}, new_metadata, formats, format} = this.state

        return (
            <div className='media-info'>
                <Modal
                    className = 'media-info-modal'
                    visible   = {visible}
                    closable  = {true}
                    onOk={this.on_save}
                    onCancel={this.close}
                    footer={[
                        <Button key="submit" type="primary" loading={loading} onClick={this.on_save}>
                            {new_metadata.length ? (loading ? 'saving':'save') : 'close'}
                        </Button>
                    ]}>
                    <Spin spinning={loading && (!(format === '' && !Object.keys(metadata).length) || !metadata)}>
                        <div className={'media-header'}>
                            <h1>{'Media Info'}</h1>

                            <div>
                                <label>Format</label>
                                <Select value={format} dropdownMatchSelectWidth={false} size={'small'} onSelect={this.on_format_change} >
                                    {formats.map((f, index) => <Select.Option key={index} value={f.name}>{f.description}</Select.Option>)}
                                </Select>
                                <Button type="primary" shape="circle" icon="download" size={'small'} onClick={()=> this.on_download()}/>
                                <Button type="primary" shape="circle" icon="copy" size={'small'} onClick={()=> this.on_copy()}/>
                            </div>
                        </div>
                        {
                            !loading && metadata && (!format ?
                                <div>
                                    <Tree showLine defaultExpandedKeys={[path, 'metadata']}>
                                        <Tree.TreeNode selectable={false} title={
                                            <span className={'media-title'}>{path}</span>
                                        } key={path}>

                                            {
                                                (Object.keys(metadata.general||{})||[]).map((key, i) =>
                                                    <Tree.TreeNode selectable={false} title={
                                                        <div className={'property'}>
                                                            <span>{key + ' : '}</span>
                                                            <span>{metadata.general[key]}</span>
                                                        </div>
                                                    } key={i}/>
                                                )
                                            }

                                            {
                                                (metadata.video||[]).filter(o=> Object.keys(o).length).length &&
                                                <Tree.TreeNode selectable={false} title={
                                                    <span className={'media-title'}>{'Videos Streams'}</span>
                                                } key={'videos'}>
                                                    {
                                                        (metadata.video||[]).map((video, index) =>
                                                            <Tree.TreeNode selectable={false} title={
                                                                <span className={'media-title'}>{'Track #' + video.id}</span>
                                                            } key={'video' + video.id} >
                                                                {
                                                                    (Object.keys(video)||[]).map((p, i) =>
                                                                        <Tree.TreeNode selectable={false} title={
                                                                            <div className={'property'}>
                                                                                <span>{p + ' : '}</span>
                                                                                <span>{video[p]}</span>
                                                                            </div>
                                                                        } key={i} />
                                                                    )
                                                                }
                                                            </Tree.TreeNode>
                                                        )
                                                    }
                                                </Tree.TreeNode>
                                            }

                                            {
                                                (metadata.audio||[]).filter(o=> Object.keys(o).length).length &&
                                                <Tree.TreeNode selectable={false} title={ <span className={'media-title'}>{'Audios Streams'}</span>} key={'Audios'}>
                                                    {
                                                        (metadata.audio||[]).map((audio, index) =>
                                                            <Tree.TreeNode selectable={false} title={
                                                                <span className={'media-title'}>{'Track #' + audio.id}</span>
                                                            } key={'audio' + audio.id} >
                                                                {
                                                                    (Object.keys(audio)||[]).map((p, i) =>
                                                                        <Tree.TreeNode selectable={false} title={
                                                                            <div className={'property'}>
                                                                                <span>{p + ' : '}</span>
                                                                                <span>{audio[p]}</span>
                                                                            </div>
                                                                        } key={i} />
                                                                    )
                                                                }
                                                            </Tree.TreeNode>
                                                        )
                                                    }
                                                </Tree.TreeNode>
                                            }

                                            {
                                                (metadata.s3_metadata||[]).filter(o=> Object.keys(o).length).length &&
                                                <Tree.TreeNode selectable={false} title={ <span className={'media-title'}>{'S3 Metadata'}</span>} key={'s3_metadata'}>
                                                    {
                                                        (metadata.s3_metadata||[]).map((p, i) =>
                                                            <Tree.TreeNode selectable={false} title={
                                                                <div className={'property'}>
                                                                    <span>{p.name + ' : '}</span>
                                                                    <span>{p.value}</span>
                                                                </div>
                                                            } key={i} />
                                                        )
                                                    }
                                                </Tree.TreeNode>
                                            }

                                            <Tree.TreeNode selectable={false} title={ <span className={'media-title'}>{'Metadata'}</span>} key={'metadata'}>
                                                {
                                                    (metadata.metadata||[]).map((p, i) =>
                                                        <Tree.TreeNode selectable={false} title={
                                                            <div className={'property metadata'}>
                                                                {/*data-placeholder={p.name} contentEditable="true"  onInput={e=> this.on_edit_metadata_input(i, 'key', e.target.textContent)}*/}
                                                                <p name="key">{p.name}</p>
                                                                <span> | </span>
                                                                <p name="value">{p.value}</p>
                                                                <Icon type="close-circle-o" onClick={()=> this.on_delete_metadata(i, p.key)}/>
                                                            </div>
                                                        } key={i} />
                                                    )
                                                }
                                                {
                                                    (new_metadata||[]).map((p, i) =>
                                                        <Tree.TreeNode selectable={false} title={
                                                            <div className={'property edit'}>
                                                                <input name="key" value={p.key} placeholder="Insert key here..."
                                                                       onChange={e=> this.on_new_metadata_input(i, e.target.name, e.target.value)}/>
                                                                <span> : </span>
                                                                <input name='value' value={p.value} placeholder="Insert value here..."
                                                                       onInput={e=> this.on_new_metadata_input(i, e.target.name, e.target.value)}/>
                                                                <Icon type="close-circle-o" onClick={()=> this.on_remove_new_metadata(i, p.key)}/>
                                                            </div>
                                                        } key={'news3meta' + i}/>)
                                                }
                                                {
                                                    !loading && <Tree.TreeNode className={'last-edit'} selectable={false}
                                                                               title={
                                                                                   <Button onClick={()=> this.on_add_new_metadata()} size={'small'} key={'addnewmeta'}>
                                                                                       <Icon type="plus" />add metadata
                                                                                   </Button>
                                                                               }/>
                                                }
                                            </Tree.TreeNode>
                                        </Tree.TreeNode>
                                    </Tree>
                                </div> :
                                <SyntaxHighlighter className='syntax-highlighter' language={format.includes('JSON')?'json':'xml'} style={docco}>{format.includes('JSON')?JSON.stringify(metadata):String(metadata)}</SyntaxHighlighter>)
                        }
                    </Spin>
                </Modal>
            </div>
        )
    }
}
